export default {"src":"/_next/static/media/socialsecuritycalc.a031ed38.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};